import {
  OptionsDataType,
  STATUS_BADGE_TYPE,
} from "../../../../../../components";

/**
 * Get status options mapping based on current status
 * @param currentStatusKey - The current status Key (e.g., "Status.Open")
 * @param statusList - The full list from Sitecore (CreateNewNISParticipant.NISStatus.NISParticipantStatusList)
 * @returns Object containing defaultStatus and possibleValues for the dropdown
 */
export const getStatusOptionsMapping = (
  currentStatusKey: string,
  statusList: OptionsDataType[],
) => {
  // Helper function to find status by Key
  const findStatusByKey = (key: string) =>
    statusList.find((item: OptionsDataType) => item.value === key);

  // Get all status items from the list using their Keys
  const unableToValidate = findStatusByKey(STATUS_BADGE_TYPE.unableToValidate);
  const ineligible = findStatusByKey(STATUS_BADGE_TYPE.ineligible);
  const createInError = findStatusByKey(STATUS_BADGE_TYPE.createdInError);

  switch (currentStatusKey) {
    case STATUS_BADGE_TYPE.open:
      return {
        defaultStatus: unableToValidate,
        possibleValues: [unableToValidate, ineligible, createInError].filter(
          Boolean,
        ) as OptionsDataType[],
      };

    case STATUS_BADGE_TYPE.unableToValidate:
      return {
        defaultStatus: ineligible,
        possibleValues: [ineligible, createInError].filter(
          Boolean,
        ) as OptionsDataType[],
      };

    case STATUS_BADGE_TYPE.ineligible:
      return {
        defaultStatus: unableToValidate,
        possibleValues: [unableToValidate, createInError].filter(
          Boolean,
        ) as OptionsDataType[],
      };

    default:
      return {
        defaultStatus: null,
        possibleValues: [],
      };
  }
};

export const isStatusCreatedInError = (statusKey: string) =>
  statusKey === STATUS_BADGE_TYPE.createdInError;
